"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Logistic = function Logistic(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M6.763 15.845a1.227 1.227 0 110 2.455 1.227 1.227 0 010-2.455zm5.93 0a1.227 1.227 0 110 2.455 1.227 1.227 0 010-2.455zM9.97 6.496c.414 0 .784.245.949.616l.043.115 1.911 6.145h.941a.706.706 0 01.645.412l.036.097.28.998h.423a.244.244 0 01.247.244.244.244 0 01-.189.229l-.063.006h-.28l.28.939a.784.784 0 01-.65.996l-.104.007h-.061c.011-.08.017-.16.016-.241a1.703 1.703 0 00-3.404 0l.006.12.014.12H8.446c.013-.08.02-.16.02-.24a1.703 1.703 0 00-3.404 0l.004.12.013.12h-.227a.84.84 0 01-.834-.735l-.007-.105v-4.743a.84.84 0 01.735-.834l.106-.007h.737v-3.95a.423.423 0 01.285-.41l.076-.019h4.02zm3.06-1.485a.24.24 0 01.305.16l3.15 10.198h2.574a.244.244 0 01.244.244l-.008.063a.244.244 0 01-.236.18h-2.748c-.118 0-.264-.226-.264-.246L12.873 5.317a.244.244 0 01.157-.306zm6.3 6.145l.037.092.67 2.166a.602.602 0 01-.311.721l-.09.035-2.163.647a.602.602 0 01-.724-.308l-.035-.09-.67-2.165a.605.605 0 01.312-.724l.09-.036.694-.215.33 1.073a.207.207 0 00.21.147l.054-.01.3-.084a.21.21 0 00.15-.209l-.01-.054-.33-1.07.764-.225a.608.608 0 01.723.31zM9.78 6.972H6.379a.306.306 0 00-.292.234l-.008.069v3.609H8.04c.068 0 .135.008.202.022l.098.025h.03c.26.083.482.257.623.49a1.6 1.6 0 01.35.93c.058.956.651 1.018.776 1.02h.022l2.18.026-1.659-5.324a.154.154 0 00-.095-.097l-.047-.009H6.765a.244.244 0 01-.056-.481l.056-.006h3.713a.723.723 0 00-.698-.508z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(Logistic);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Logistic, "Logistic", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Logistic.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Logistic.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();